module.exports = __webpack_public_path__ + "static/media/relaystream-logo.070697c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/relaystream-logo.png
// module id = 203
// module chunks = 0